// src/components/Header.js
import React, { useState } from 'react';
import './Header.css';
import logo from '../assets/logo.png'; // Make sure to add your logo image in src/assets/ folder

const Header = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);

  // Services Dropdown Items
  const servicesItems = [
    { name: 'Medical Billing', path: '/services/medical-billing' },
    { name: 'Medical Coding', path: '/services/medical-coding' },
    { name: 'Denials Management', path: '/services/denials-management' },
    { name: 'AR Follow Up', path: '/services/ar-follow-up' },
    { name: 'Credentialing', path: '/services/credentialing' },
    { name: 'Medical Billing Audit', path: '/services/medical-billing-audit' },
  ];

  // More Dropdown Items
  const moreItems = [
    { name: 'Pricing', path: '/pricing' },
    { name: 'Testimonials', path: '/testimonials' },
    { name: 'Outsource Medical Billing', path: '/outsource-medical-billing' },
    { name: 'Benefits Of Outsourcing', path: '/benefits-of-outsourcing' },
    { name: 'Career', path: '/career' },
    { name: 'Blog', path: '/blog' },
    { name: 'HIPAA', path: '/hipaa' },
  ];

  const handleMouseEnter = (dropdown) => {
    setActiveDropdown(dropdown);
  };

  const handleMouseLeave = () => {
    setActiveDropdown(null);
  };

  return (
    <header className="providers-header">
      {/* Top Bar (Dark Blue) */}
      <div className="top-bar">
        <div className="container">
          <div className="top-flex">
            <div className="contact-left-group">
              <div className="contact-item">
                <i className="fas fa-envelope"></i>
                <span>info@oxymedbs.com</span>
              </div>
            </div>
            <div className="contact-item">
              <i className="fas fa-phone-alt"></i>
              <span>(757) 540-1740</span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar (White with Logo, Nav, Demo Button) */}
      <div className="bottom-bar">
        <div className="container">
          <div className="nav-wrapper">
            {/* Logo Area - With Image Logo */}
            <div className="logo-area">
              <img src={logo} alt="OxyMed Billing Solutions LLC" className="header-logo" />
            </div>

            {/* Navigation Menu with Dropdowns */}
            <ul className="nav-menu">
              <li><a href="/">Home</a></li>
              
              {/* Services Dropdown */}
              <li 
                className="dropdown"
                onMouseEnter={() => handleMouseEnter('services')}
                onMouseLeave={handleMouseLeave}
              >
                <a href="/services">
                  Services <i className="fas fa-chevron-down dropdown-icon"></i>
                </a>
                {activeDropdown === 'services' && (
                  <ul className="dropdown-menu">
                    {servicesItems.map((item, index) => (
                      <li key={index}>
                        <a href={item.path}>{item.name}</a>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
              
              <li><a href="/states">States We Serve</a></li>
              <li><a href="/specialties">Specialties</a></li>
              
              {/* More Dropdown */}
              <li 
                className="dropdown"
                onMouseEnter={() => handleMouseEnter('more')}
                onMouseLeave={handleMouseLeave}
              >
                <a href="/more">
                  More <i className="fas fa-chevron-down dropdown-icon"></i>
                </a>
                {activeDropdown === 'more' && (
                  <ul className="dropdown-menu">
                    {moreItems.map((item, index) => (
                      <li key={index}>
                        <a href={item.path}>{item.name}</a>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
              
              <li><a href="/contact">Contact Us</a></li>
            </ul>

            {/* Schedule a Demo Button */}
           <button
  className="demo-btn"
  onClick={() => window.location.href = 'https://oxymedbs.com/contact'}
>
  Schedule a Demo
  <i className="fas fa-arrow-right"></i>
</button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;